// extracted by mini-css-extract-plugin
export var calendar = "xgjGAEgIJL_3q7yqqzbg";
export var calendarButton = "yGLj39d5SFwTiSWffvAG";
export var calendarGrid = "F01cQWvANhe4axc7pXy6";
export var calendarHeader = "N0UmeePuNiT60wZ7GHI0";
export var calendarHeaderTitle = "gYkkBHdUVjRxLLJysf09";
export var calendarMonth = "MRnfmEEySaM5GBFwjqpI";
export var calendarWeekday = "pqG4fr_rMNL_uBFDAZFW";
export var screenReaderOnly = "VAKG4p7sNDR2HcZJBspm";